(() => {
  class FjHomeHero {
    constructor(element) {
      this.element = element;
      this.items = Array.from(this.element.querySelectorAll('[data-fj-home-hero-item]'));
      this.dots = this.element.querySelector('[data-fj-home-hero-dots]');
      this.dotButtons = this.dots ? Array.from(this.dots.querySelectorAll('[data-fj-home-hero-dot]')) : [];
      this.cycleMs = 8000;
      this.timer = null;
      this.activeIndex = this.items.findIndex(item => !item.classList.contains('fj-home-hero__item--hidden'));

      if (this.activeIndex < 0) {
        this.activeIndex = 0;
      }

      this.init();
    }

    init() {
      this.syncItems();
      this.setupDots();
      this.doSwipe();
      this.startCycle();
    }

    setupDots() {
      if (!this.dots) return;

      if (this.items.length < 2 || this.dotButtons.length < 2) {
        this.dots.hidden = true;
        return;
      }

      this.dots.hidden = false;

      this.dotButtons.forEach((dot, itemIndex) => {
        dot.hidden = itemIndex >= this.items.length;

        dot.addEventListener('click', () => {
          this.showItem(itemIndex);
          this.startCycle();
        });
      });

      this.updateDots();
    }

    syncItems() {
      this.items.forEach((item, itemIndex) => {
        item.classList.toggle('fj-home-hero__item--hidden', itemIndex !== this.activeIndex);
      });
    }

    updateDots() {
      this.dotButtons.forEach((dot, dotIndex) => {
        const isActive = dotIndex === this.activeIndex;
        dot.classList.toggle('fj-home-hero__dot--active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    restartAnimations(item) {
      item.querySelectorAll('[data-fj-home-hero-animate], [data-fj-bottle-animate]').forEach(el => {
        el.style.animation = 'none';
        el.getBoundingClientRect();
        el.style.animation = '';
      });
    }

    showItem(index) {
      if (!this.items.length) return;

      this.activeIndex = (index + this.items.length) % this.items.length;
      this.syncItems();
      this.updateDots();
      this.restartAnimations(this.items[this.activeIndex]);
    }

    advanceItem() {
      this.showItem(this.activeIndex + 1);
    }

    startCycle() {
      this.stopCycle();

      if (this.items.length > 1) {
        this.timer = setInterval(() => this.advanceItem(), this.cycleMs);
      }
    }

    stopCycle() {
      if (!this.timer) return;

      clearInterval(this.timer);
      this.timer = null;
    }

    doSwipe() {
      if (this.items.length < 2) return;

      const isSwipe = 50;

      let startX = 0;
      let startY = 0;
      let isDragging = false;

      this._onPointerDown = (event) => {
        if (!event.isPrimary) return;

        // Ignore drags that start on the 3D bottle — that's camera-orbit
        // interaction, not a slide-swipe gesture.
        if (event.target.closest('[data-fj-bottle]')) return;

        startX = event.clientX;
        startY = event.clientY;
        isDragging = true;
      };

      this._onPointerUp = (event) => {
        if (!event.isPrimary || !isDragging) return;
        isDragging = false;

        const dx = event.clientX - startX;
        const dy = event.clientY - startY;

        if (Math.abs(dy) > Math.abs(dx)) return;

        if (dx < -isSwipe) {
          this.showItem(this.activeIndex + 1);
          this.startCycle();
        } else if (dx > isSwipe) {
          this.showItem(this.activeIndex - 1);
          this.startCycle();
        }
      };

      this._onPointerCancel = () => {
        isDragging = false;
      };

      this.element.addEventListener('pointerdown', this._onPointerDown);
      this.element.addEventListener('pointerup', this._onPointerUp);
      this.element.addEventListener('pointercancel', this._onPointerCancel);
    }

    destroy() {
      this.stopCycle();

      if (this._onPointerDown) {
        this.element.removeEventListener('pointerdown', this._onPointerDown);
        this.element.removeEventListener('pointerup', this._onPointerUp);
        this.element.removeEventListener('pointercancel', this._onPointerCancel);
      }
    }
  }

  const instances = new WeakMap();

  function initElement(element) {
    if (instances.has(element)) {
      instances.get(element).destroy();
    }
    instances.set(element, new FjHomeHero(element));
  }

  document.querySelectorAll('[data-fj-home-hero]').forEach(initElement);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-fj-home-hero]').forEach(initElement);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-fj-home-hero]').forEach((element) => {
      if (instances.has(element)) {
        instances.get(element).destroy();
        instances.delete(element);
      }
    });
  });
})();